export class WorkflowNames {
    public id : number;
    public workflow_name : string;
    public active_flag : string;
    public created_dt :Date;
    public created_by : string;
    public update_dt :Date;
    public updated_by : string;
    public effective_date: Date ;
    public cdt : string;
    public udt : string;
    public effdt : string;

    constructor(){
        this.cdt = null;
        this.udt = null;
        this.effdt = null;
        this.id = null;
        this.active_flag ='';
        this.created_by = '';
        this.updated_by ='';
        this.created_dt = null;
        this.update_dt = null;
        this.workflow_name = '';
        this.effective_date = null;
    }
}
